import React from "react";
import { Selector } from "../../../services/visualLibraryService";
import { i18n } from "../../../services/i18nService";
import { withAppState } from "../../../state";
import { TextDisclaimerStyled } from "../styles/Styled";
import { isAccessAllowedByParentalLevel } from "../../../services/parentalControlService";

export const ParentalControl = withAppState(
  ({ parentalControlList, onItemSelected, applicationState: { parentalLevel } }) => {
    return (
      <React.Fragment>
        <Selector
          items={parentalControlList.map(item => ({
            key: item,
            title: i18n.get(`pages.settings.parentalControl.level.${item}`),
            active: item === parentalLevel
          }))}
          onItemSelected={onItemSelected}
          selectedIndex={parentalControlList.findIndex(item => item === parentalLevel)}
        />
        {!isAccessAllowedByParentalLevel() && (
          <TextDisclaimerStyled text={i18n.get("pages.settings.parentalControl.restricted")} type="secondary" />
        )}
      </React.Fragment>
    );
  }
);
